// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogNav_wrapper__N95Zp"};